import React, { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "bios-theme";
const ThemeContext = createContext({ theme: "light", toggle: () => {} });

export function ColorThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    // Honour an explicit user choice from a previous visit. We deliberately
    // ignore the OS-level `prefers-color-scheme` for the default. First-time
    // visitors on a phone land on dark (the light-mode photo background can't
    // fill a portrait screen and is the heaviest thing on mobile); larger
    // screens open on the intended BIOS light theme. Mirrors index.html's
    // pre-hydration script so there's no flash. The toggle still works and
    // persists, so a phone visitor can switch to light and it sticks.
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
    const isPhone =
      typeof window.matchMedia === "function" && window.matchMedia("(max-width: 640px)").matches;
    return isPhone ? "dark" : "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>;
}

export const useColorTheme = () => useContext(ThemeContext);
